import Ajax from '../common/ajax'
import ApiBase from './api-base'

export default {
  ...ApiBase,
  model: 'role',
  getList (queryParam = { pageSize: 10000, pageNum: 1 }) {
    return Ajax.get(`/api/gradeOrganization/v1/${this.model}/listAll`, queryParam)
  }
}
